export enum RedirectToSamlTaskType {
    EvidencioGrading = 'evidencioGrading',
    EvidencioRespiAllerPrickTestMeasurements = 'evidencioPrickTestMeasurements',
}
